const displayOnHomepage = window.location.pathname === '/' || window.location.href.includes('assets.test') || window.location.href.includes('assets.dev.gcp') || getCookie('808_enabled');
const urlParams = new URLSearchParams(window.location.search);
const has808Share = urlParams.has('808_share');
const hasHash = urlParams.has('hash');
// Helper function to get cookie value by name
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

document.addEventListener('DOMContentLoaded', () => {
    // Check for URL parameters
    
    // Store parameters globally for use in show808Player
    window._808Params = {
        share: has808Share ? urlParams.get('808_share') : null,
        hash: hasHash ? urlParams.get('hash') : null
    };

    // Auto-show player if both required parameters are present
    if (displayOnHomepage && has808Share && hasHash) {
        show808Player();
    }

    const logo = document.querySelector('.assets-site-header__menu-logo');
    logo.addEventListener('click', (e) => {
        if (displayOnHomepage) {
            e.preventDefault();
            show808Player();
        }
    });


});

function show808Player() {
    // Lock body scroll
    document.body.style.overflow = 'hidden';
    const sampler = document.createElement('div');
    sampler.id = 'sampler';

    const css = document.createElement('style');
    css.innerHTML = /*css*/`
        #sampler {
            position: absolute;
            top: 10vh;
            bottom: 10vh;
            left: 5vw;
            right: 5vw;
            z-index: 999;
            background: #fff;
            width: 90vw;
            box-shadow: 0 10px 20px rgba(0,0,0,.6), 0 40px 700px 500px rgba(0,0,0,.6);
            box-sizing: border-box;
            border-radius: 1rem;
            overflow: hidden;
            padding: 10px;
        }
        
        #sampler iframe {            width: 100%;
            height: 100%;
            border-radius: 0.75rem;
            background-color: #252525;
        }

        .sampler-background {
            height: calc(100% - 250px);
            margin-top: 1.5rem;
            // max-height: clamp(25%, 15vw, 40%);
        }

        .sampler-close {
            text-decoration: none;
            right: 1rem;
            top: 0.5rem;
            position: absolute;
            transform: rotate(45deg);
            color: inherit;
            font-weight: 700;
            font-size: 26px;
        }

        .sampler-message {
            text-align: center;
            font-size: 1rem;
            padding: 1rem 1.5rem;
        }

        .sampler-mesage a {
            color: #237fa7;
        }

        .sampler-message h2 {
            text-transform: uppercase;
            font-size: 2rem;
            font-weight: 700;
            margin-bottom: 4px;
        }

        .sampler-home {
            display: block;
            width: 100%;
            margin-top: 8px;
            text-align: center;
            pointer-events: none;
        }

        .sampler-loading {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 1000;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
        }

        .sampler-spinner {
            width: 40px;
            height: 40px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid #237fa7;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }

        .sampler-loading-text {
            color: #666;
            font-size: 14px;
            font-weight: 500;
        }

        @media screen and (max-width: 876px) and (min-width: 748px) {
            .sampler-background {
                // max-height: clamp(40%, 60vw, 70%);
            }
        }
        @media screen and (max-width: 747px) and (min-width: 501px) {
            .sampler-background {
                // max-height: clamp(30%, 65vw, 60%);
            }
        }
        @media screen and (max-width: 500px) {
            .sampler-background {
                // max-height: clamp(40%, 15vw, 60%);
            }
        }

        @media screen and (max-width: 768px) {
            #sampler {
                left: 0;
                top: 0;
                bottom: 0;
                width: 100%;
                margin: 0 auto;
                border-radius: 0;
            }
        }
    `;
    document.head.appendChild(css);

    const swRoot = () => {
        if (window.location.href.includes('www.sweetwater.com')) {
            return 'https://www.sweetwater.com';
        }
        return 'https://dev.sweetwater.com';
    }

    // Build iframe URL with parameters if they exist
    const buildIframeUrl = () => {
        let url = `${swRoot()}/feature/808/`;
        const params = new URLSearchParams();

        if (window._808Params && window._808Params.share && window._808Params.hash) {
            params.append('808_share', window._808Params.share);
            params.append('hash', window._808Params.hash);
        }

        if (params.toString()) {
            url += '?' + params.toString();
        }

        return url;
    }

    sampler.innerHTML = /*html*/`
        <div aria-label="Sweetwater" class="sampler-home">
            <img src="https://media.sweetwater.com/m/header/logo/sw-logo-808.svg" alt="Sweetwater 808 Logo" width="180" role="presentation"/>
        </div>
        <a href="#" aria-label="close sampler" class="sampler-close">+</a>
        <div class="sampler-background">
            <div class="sampler-loading" id="sampler-loading">
                <div class="sampler-spinner"></div>
                <div class="sampler-loading-text">Loading 808 Player...</div>
            </div>
            <iframe src="${buildIframeUrl()}" id="sampler-iframe"></iframe>
        </div>
        <div class="sampler-message">
            <h2>${has808Share && hasHash ? 'Someone shared a beat with you!' : ''} Happy 808 Day!</h2>
            Make an 808 beat above and share it with friends! Shared beats expire August 15th. For the best experience, play beats on desktop.<br>
            <a href="https://www.sweetwater.com/insync/history-roland-808" class="sampler-learnmore">Learn more about the legendary TR-808 here.</a>
        </div>
    `;

    document.body.appendChild(sampler);

    // Handle iframe loading states
    const iframe = document.getElementById('sampler-iframe');
    const loading = document.getElementById('sampler-loading');

    iframe.addEventListener('load', () => {
        // Hide loading spinner when iframe is loaded
        loading.style.display = 'none';
    });

    iframe.addEventListener('error', () => {
        // Hide loading spinner and show error message if iframe fails to load
        loading.innerHTML = `
            <div class="sampler-loading-text" style="color: #e74c3c;">
                Failed to load 808 Player. Please try again.
            </div>
        `;
    });

    document.querySelector('.sampler-close').addEventListener('click', (e) => {
        e.preventDefault();
        hide808player();
    });

    // Close modal when clicking outside of it
    const handleOutsideClick = (e) => {
        // Check if the click is outside the sampler modal
        if (!sampler.contains(e.target)) {
            hide808player();
        }
    };

    // Add the outside click listener after a short delay to prevent immediate closing
    setTimeout(() => {
        document.addEventListener('click', handleOutsideClick);
    }, 100);

    window._808 = {
        html: sampler,
        css: css,
        outsideClickHandler: handleOutsideClick,
    }

}

function hide808player() {
    document.body.style.overflow = 'auto';
    if (window._808) {
        window._808.html.remove();
        window._808.css.remove();
        // Remove the outside click event listener
        if (window._808.outsideClickHandler) {
            document.removeEventListener('click', window._808.outsideClickHandler);
        }
    }
}

// Listen for messages from the 808 iframe
window.addEventListener('message', function(event) {
    if (event.data.type === '808_share_beat') {
        // Iframe wants to share a beat - build the URL and copy to clipboard
        const hash = event.data.hash;
        const shareUrl = buildShareUrl(hash);

        // Copy to clipboard
        if (navigator.clipboard) {
            navigator.clipboard.writeText(shareUrl).then(() => {
                console.log('Beat URL copied to clipboard!', shareUrl);
                showToast('Beat copied to clipboard!', 'success');
            }).catch(err => {
                console.error('Failed to copy to clipboard:', err);
                showToast('Failed to copy beat to clipboard', 'error');
            });
        } else {
            // Fallback for older browsers
            console.log('Share URL:', shareUrl);
            showToast('Beat URL ready (check console)', 'info');
        }
    }
});

/**
 * Build the complete share URL using current page URL but replacing query params
 */
function buildShareUrl(hash) {
    try {
        const url = new URL(window.location.href);
        // Clear existing query parameters and set our sharing parameters
        url.search = '';
        url.searchParams.set('808_share', '1');
        url.searchParams.set('hash', hash);
        return `${url.toString()}&utm_source=social&utm_medium=social&utm_campaign=808DayShare`;
    } catch (error) {
        console.error('Error building share URL:', error);
        // Fallback to simple URL
        return `${window.location.origin}/?808_share=1&hash=${hash}&utm_source=social&utm_medium=social&utm_campaign=808DayShare`;
    }
}

/**
 * Show a toast notification
 */
function showToast(message, type = 'info') {
    // Remove any existing toast
    const existingToast = document.querySelector('.beat-share-toast');
    if (existingToast) {
        existingToast.remove();
    }

    // Create toast element
    const toast = document.createElement('div');
    toast.className = `beat-share-toast beat-share-toast--${type}`;
    toast.textContent = message;

    // Add CSS if not already present
    if (!document.querySelector('#beat-share-toast-styles')) {
        const style = document.createElement('style');
        style.id = 'beat-share-toast-styles';
        style.textContent = `
            .beat-share-toast {
                position: fixed;
                top: 20px;
                right: 20px;
                background: #333;
                color: white;
                padding: 12px 20px;
                border-radius: 6px;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                font-size: 14px;
                font-weight: 500;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                z-index: 10000;
                opacity: 0;
                transform: translateX(100%);
                transition: all 0.3s ease;
                max-width: 300px;
            }
            .beat-share-toast--success {
                background: #10b981;
            }
            .beat-share-toast--error {
                background: #ef4444;
            }
            .beat-share-toast--info {
                background: #3b82f6;
            }
            .beat-share-toast.show {
                opacity: 1;
                transform: translateX(0);
            }
        `;
        document.head.appendChild(style);
    }

    // Add to page
    document.body.appendChild(toast);

    // Trigger animation
    setTimeout(() => {
        toast.classList.add('show');
    }, 10);

    // Remove after 3 seconds
    setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => {
            if (toast.parentNode) {
                toast.remove();
            }
        }, 300);
    }, 3000);
}



